module.exports = __webpack_public_path__ + "icon.png";